import {
  ContractDetailsOtherContractInformationCustomFieldFragment,
  ContractDetailsOtherContractInformationCustomValueFragment,
} from 'generated/resources/graphql'

import CustomField from './CustomField'

interface Props {
  customFields: ContractDetailsOtherContractInformationCustomFieldFragment[]
  contractVersionValues: ContractDetailsOtherContractInformationCustomValueFragment[]
}

const CustomFields = ({ customFields, contractVersionValues }: Props) => {
  const orderedCustomFields = customFields.slice().sort((a, b) => {
    if (!a.position) return 1
    if (!b.position) return -1

    return a.position - b.position
  })

  return (
    <>
      {orderedCustomFields.map((customField) => {
        let customValue = contractVersionValues.find((value) => {
          return value.field.id === customField.id
        })

        // This is a workaround to handle the case where the custom field is not in the contract version values
        // because the field id is not the same as the field label text. It happens due to the duplications that we have at database level.
        // We need to tackle the root cause of this issue and then remove this workaround.
        if (!customValue) {
          customValue = contractVersionValues.find((value) => {
            return value.field?.labelText === customField.labelText
          })
        }

        return (
          <CustomField
            key={customField.identifier}
            customField={customField}
            customValue={customValue}
          />
        )
      })}
    </>
  )
}

export default CustomFields
